export const noop = () => {
  /* noop */
};

export const phoneNumberOrEmptyStringRegEx = new RegExp(/^$|^[0-9]+$/i);
export const phoneNumberRegEx = new RegExp(/^[0-9]+$/i);
export const emailOrEmptyStringRegEx = new RegExp(/^$|^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);
export const emailRegEx = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);
